var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDateFrame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 5,
    fill: "#F4F6F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip0_367_5689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.625 11.8125H12.375C12.0643 11.8125 11.8125 12.0643 11.8125 12.375V23.625C11.8125 23.9357 12.0643 24.1875 12.375 24.1875H23.625C23.9357 24.1875 24.1875 23.9357 24.1875 23.625V12.375C24.1875 12.0643 23.9357 11.8125 23.625 11.8125Z",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.375 10.6875V12.9375",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.625 10.6875V12.9375",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8125 15.1875H24.1875",
    stroke: "#1A1A1A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.375 15.1875H23.625C23.9357 15.1875 24.1875 15.3707 24.1875 15.5966V23.7784C24.1875 24.0043 23.9357 24.1875 23.625 24.1875H12.375C12.0643 24.1875 11.8125 24.0043 11.8125 23.7784V15.5966C11.8125 15.3707 12.0643 15.1875 12.375 15.1875ZM21.0616 18.5303C21.3545 18.2374 21.3545 17.7626 21.0616 17.4697C20.7687 17.1768 20.2938 17.1768 20.0009 17.4697L17.1562 20.3143L15.9991 19.1572C15.7062 18.8643 15.2313 18.8643 14.9384 19.1572C14.6455 19.4501 14.6455 19.9249 14.9384 20.2178L16.6259 21.9053C16.9188 22.1982 17.3937 22.1982 17.6866 21.9053L21.0616 18.5303Z",
    fill: "#1A1A1A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_367_5689"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateFrame);
export default __webpack_public_path__ + "static/media/date-frame.a03d6423.svg";
export { ForwardRef as ReactComponent };